import { useState } from "react"
import { Button, ModalBody, Modal, ModalContent, ModalHeader, ModalOverlay, Input, ModalCloseButton, Text, InputGroup, InputRightElement } from "@chakra-ui/react"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import { toast } from 'react-hot-toast'
import api from "../../api"
import { useDispatch } from "react-redux"
import { getUsers } from "../../actions/userActions"

const validationSchema = Yup.object().shape({
    name: Yup.string().min(2).required("El nombre es requerido"),
    email: Yup.string().email("El email no es válido").required("El email es requerido"),
    password: Yup.string().min(6, 'Mínimo 6 caracteres').required("La contraseña es requerida"),
    confirmPassword: Yup.string().oneOf([Yup.ref("password"), null], "Las contraseñas no coinciden")
})

const NewUserModal = ({onClose, isOpen}) => {
    const [showPassword, setShowPassword] = useState(false)
    const dispatch = useDispatch()

    const handlePasswordClick = () => {
        setShowPassword(!showPassword)
    }

    const createUserRequest = async (values) => {
        try{
            const { data } = await api.post("/users", values)
            return [true, data]
        }catch(error){
            console.log(error)
            return [false, error]
        }
    }

    const handleSubmit = async (values, {setSubmitting}) => {
        try{
            console.log(values)
            const [ok, res] = await createUserRequest(values)
            console.log(res)
            if(!ok) throw new Error()
            toast.success("Usuario creado con éxito.")
            setSubmitting(false)
            dispatch(getUsers({ page: 1, limit: 10 }))
            onClose()
        }catch(error){
            console.log(error)
            toast.error("Algo salió mal, inténtalo más tarde.")
            onClose()
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="xl"
        >
            <ModalOverlay />
            <Formik
                initialValues={{
                    name: "",
                    email: "",
                    password: "",
                    confirmPassword: ""
                }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({
                    values,
                    handleChange,
                    handleBlur,
                    errors,
                    dirty,
                    isValid,
                    isSubmitting,
                    setFieldValue,
                    handleSubmit,
                }) => (
                    <ModalContent>
                        <ModalHeader>
                            Nuevo Usuario
                            <ModalCloseButton />
                        </ModalHeader>
                        <ModalBody>
                            <Form
                                onSubmit={handleSubmit}
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px"
                                }}
                            >
                                <Input
                                    name="name"
                                    label="Nombre"
                                    placeholder="Nombre"
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.name}
                                />
                                {errors.name && <Text fontSize='small' color='red.500' >{errors.name}</Text>}
                                <Input
                                    name="email"
                                    label="Email"
                                    placeholder="Email"
                                    value={values.email}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.email}
                                />
                                {errors.email && <Text fontSize='small' color='red.500' >{errors.email}</Text>}
                                <InputGroup size='md'>
                                    <Input
                                        pr='4.5rem'
                                        type={showPassword ? 'text' : 'password'}
                                        name="password"
                                        label="Contraseña"
                                        placeholder="Contraseña"
                                        value={values.password}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.password}
                                    />
                                    <InputRightElement width='4.5rem'>
                                        <Button h='1.75rem' size='sm' onClick={handlePasswordClick}>
                                        {showPassword ? 'Hide' : 'Show'}
                                        </Button>
                                    </InputRightElement>
                                </InputGroup>
                                {errors.password && <Text fontSize='small' color='red.500' >{errors.password}</Text>}
                                <Input
                                    name="confirmPassword"
                                    type={"password"}
                                    label="Confirmar Contraseña"
                                    placeholder="Confirmar Contraseña"
                                    value={values.confirmPassword}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.confirmPassword}
                                />
                                {errors.confirmPassword && <Text fontSize='small' color='red.500' >{errors.confirmPassword}</Text>}
                                <Button
                                    type="submit"
                                    colorScheme="facebook"
                                    mt={4}
                                    isLoading={isSubmitting}
                                    disabled={
                                        !dirty 
                                        || !isValid
                                        || isSubmitting
                                    }
                                    onClick={handleSubmit}
                                    mb='20px'
                                >
                                    Crear
                                </Button>
                            </Form>
                        </ModalBody>
                    </ModalContent>
                )}
            </Formik>
        </Modal>
    )
}

export default NewUserModal